import {
  PINNING_CAPABILITIES,
  PinningCapabilityName,
} from './pinning-capabilities';

import { CapabilityRule } from '~types/capability.type';

/**
 * Aggregate capability registry.
 *
 * Each feature area maintains its own registry file (one union type + one
 * `Record`), and this module merges them so consumers (`useCan`, `<Can>`,
 * `canAccessCapability`) keep a single entry point. To add a domain, follow
 * the maintenance protocol documented in `pinning-capabilities.ts` (ported
 * from web-dashboard's `station-capabilities.ts`):
 *   1. Create `<domain>-capabilities.ts` exporting `<Domain>CapabilityName`
 *      and `<DOMAIN>_CAPABILITIES`.
 *   2. Add the name to the `CapabilityName` union and spread the record into
 *      `CAPABILITIES` below.
 */

export type CapabilityName = PinningCapabilityName;

export const CAPABILITIES: Record<
  CapabilityName,
  CapabilityRule<CapabilityName>
> = {
  ...PINNING_CAPABILITIES,
};
